import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { ROUTES } from "@repo/core/routes";
import { useProposalFlowNavigation } from "../../utils/proposalFlowNavigation";
import { useRef, useState } from "react";
import { useProposal } from "@repo/core/hooks/useProposal";
import { mockFinancialServices } from "@repo/core/stores/proposalForm/mocks";

export const SelectFinancialServiceController = () => {
  const alertModalRef = useRef<IModalRefProps>(null);
  const { completeStep, goToPreviousStep } = useProposalFlowNavigation();
  const { isMobile } = useDimensions();
  const {
    selectedFinancialService,
    setSelectedFinancialService,
    isFidelityProposal
  } = useProposal();

  const [selectedFinancialServiceId, setSelectedFinancialServiceId] = useState<
    string | null
  >(selectedFinancialService?.id || null);

  const financialServices = mockFinancialServices;

  const handleSelectFinancialService = (id: string) => {
    setSelectedFinancialServiceId(id);
  };

  const handleOnSubmitForm = () => {
    const service = financialServices.find(
      (s) => s.id === selectedFinancialServiceId
    );
    if (service) {
      setSelectedFinancialService(service);
    }

    if (isFidelityProposal) {
      completeStep(ROUTES.fidelityProposalReview);
      return;
    }

    completeStep(ROUTES.creditProposalReview);
  };

  const handleGoBack = () => {
    if (isFidelityProposal) {
      goToPreviousStep(ROUTES.fidelityProposalReview);
      return;
    }
    goToPreviousStep(ROUTES.creditProposalReview);
  };

  return {
    alertModalRef,
    handleOnSubmitForm,
    handleGoBack,
    financialServices,
    isMobile,
    selectedFinancialServiceId,
    handleSelectFinancialService
  };
};
